// Generated by https://quicktype.io

import { LookupValue } from "./lookup.model";

export interface FittingsAdminFilter {
  fittingTypeIds?: number[];
  hemisphereIds?: number[];
  partNumber?: string;
  productName?: string;
  pipeSizeIds?: number[];
  branchSizeIds?: number[];
  classIds?: number[];
  designFactorIds?: number[];
  flangeTypeIds?: number[];
  maxCeIds?: number[];
  description?: string;
  toOdataFilter(): string;
}

export function fittingsAdminFilterFactory(obj: Partial<FittingsAdminFilter>): FittingsAdminFilter {
  return {
    fittingTypeIds: obj.fittingTypeIds || [],
    hemisphereIds: obj.hemisphereIds || [],
    partNumber: obj.partNumber,
    productName: obj.productName,
    pipeSizeIds: obj.pipeSizeIds || [],
    branchSizeIds: obj.branchSizeIds || [],
    classIds: obj.classIds || [],
    designFactorIds: obj.designFactorIds || [],
    flangeTypeIds: obj.flangeTypeIds || [],
    maxCeIds: obj.maxCeIds || [],
    description: obj.description,
    toOdataFilter: () => {
      let str = '';
      if ((obj.fittingTypeIds || []).length > 0) str += `FittingTypeId in (${obj.fittingTypeIds?.map(v => `${v},`).map(v => v.substring(0, v.length - 1))}) AND `;
      if ((obj.hemisphereIds || []).length > 0) str += `HemisphereId in (${obj.hemisphereIds?.map(v => `${v},`).map(v => v.substring(0, v.length - 1))}) AND `;
      if ((obj.partNumber || '').length > 0) str += `contains(PartNumber, '${obj.partNumber}') AND `;
      if ((obj.productName || '').length > 0) str += `contains(ProductName, '${obj.productName}') AND `;
      if ((obj.pipeSizeIds || []).length > 0) str += `PipeSizeId in (${obj.pipeSizeIds?.map(v => `${v},`).map(v => v.substring(0, v.length - 1))}) AND `;
      if ((obj.branchSizeIds || []).length > 0) str += `BranchSizeId in (${obj.branchSizeIds?.map(v => `${v},`).map(v => v.substring(0, v.length - 1))}) AND `;
      if ((obj.classIds || []).length > 0) str += `ClassId in (${obj.classIds?.map(v => `${v},`).map(v => v.substring(0, v.length - 1))}) AND `;
      if ((obj.designFactorIds || []).length > 0) str += `DesignFactorId in (${obj.designFactorIds?.map(v => `${v},`).map(v => v.substring(0, v.length - 1))}) AND `;
      if ((obj.maxCeIds || []).length > 0) str += `MaxCeID in (${obj.maxCeIds?.map(v => `${v},`).map(v => v.substring(0, v.length - 1))}) AND `;
      if ((obj.flangeTypeIds || []).length > 0) str += `FlangeTypeId in (${obj.flangeTypeIds?.map(v => `${v},`).map(v => v.substring(0, v.length - 1))}) AND `;
      if ((obj.description || '').length > 0) str += `contains(Description, '${obj.description}') AND `;
      return str.substring(0, str.length - 5);
    }
  }
}

export interface FittingProduct {
  id?: number;
  partNumber?: string;
  productName?: string;
  description?: string;
  pipeSizeId?: number;
  classId?: number;
  designFactorId?: number;
  branchSizeId?: number;
  flangeTypeId?: number;
  maxDesignPressure?: number;
  minDesignTemp?: number;
  maxDesignTemp?: number;
  maxCeid?: number;
  limit125?: number;
  notes?: string;
  drawing?: string | null;
  restricted?: number;
  restrictedNotice?: string;
  inactiveDate?: Date;
  createdDate?: string;
  createdBy?: string;
  updatedDate?: string;
  updatedBy?: string;
  fittingTypeId?: number;
  hemisphereId?: number;
  hasDrawing?: boolean;
  isPreferred?: boolean;

  fittingType?: LookupValue & { imageUrl: string };
  hemisphere?: LookupValue;
  fittingPipeSize?: LookupValue;
  fittingClass?: LookupValue;
  fittingDesignFactor?: LookupValue;
  fittingBranchSize?: LookupValue;
  fittingFlangeType?: LookupValue;
  fittingMaxCe?: LookupValue;

  fittingProductAssociatedProducts?: FittingProductAssociatedProduct[];
  fittingProductDesignCodes?: FittingProductDesignCode[];
  fittingProductDesignPressures?: FittingProductDesignPressure[];

  flatterFilesExistence?: { [key: string]: FlatterFilesResponse }
}

export interface FlatterFilesResponse {
  error: boolean;
  result: string;
}

export function fittingProductFactory(obj: Partial<FittingProduct>): FittingProduct {
  return {
    id: obj.id,
    partNumber: obj.partNumber,
    productName: obj.productName,
    description: obj.description,
    pipeSizeId: obj.pipeSizeId,
    classId: obj.classId,
    designFactorId: obj.designFactorId,
    branchSizeId: obj.branchSizeId,
    flangeTypeId: obj.flangeTypeId,
    maxDesignPressure: obj.maxDesignPressure,
    minDesignTemp: obj.minDesignTemp,
    maxDesignTemp: obj.maxDesignTemp,
    maxCeid: obj.maxCeid,
    limit125: obj.limit125,
    notes: obj.notes,
    drawing: obj.drawing,
    restricted: obj.restricted,
    restrictedNotice: obj.restrictedNotice,
    inactiveDate: !!obj.inactiveDate ? new Date(obj.inactiveDate) : obj.inactiveDate,
    createdDate: obj.createdDate,
    createdBy: obj.createdBy,
    updatedDate: obj.updatedDate,
    updatedBy: obj.updatedBy,
    fittingTypeId: obj.fittingTypeId,
    hemisphereId: obj.hemisphereId,
    fittingType: obj.fittingType,
    hemisphere: obj.hemisphere,
    fittingPipeSize: obj.fittingPipeSize,
    fittingClass: obj.fittingClass,
    fittingDesignFactor: obj.fittingDesignFactor,
    fittingBranchSize: obj.fittingBranchSize,
    fittingFlangeType: obj.fittingFlangeType,
    fittingMaxCe: obj.fittingMaxCe,
    hasDrawing: obj.hasDrawing,
    isPreferred: obj.isPreferred || false
  }
}

export interface FittingProductDesignPressure {
  id: number;
  designFactorId: number;
  fittingProductId: number;
  maxDesignPressure: number;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;

  fittingDesignFactor: LookupValue;
}

export interface FittingProductDesignCode {
  id: number;
  designCodeId: number;
  fittingProductId: number;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;

  fittingDesignCode: LookupValue;
}

export interface FittingProductAssociatedProduct {
  id: number;
  fittingProductId: number;
  associatedProductId: number;
  notes: null;
  sortOrder: number;
  includedInSystemKit: boolean;
  displayColor: string;
  displayBold: boolean;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
  fittingAssociatedProduct: FittingAssociatedProduct;
}


export interface FittingAssociatedProduct {
  id: number;
  associatedProductTypeId: number;
  productNumber: string;
  productName: string;
  description: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
  associatedProductType: AssociatedProductType;
}

export interface AssociatedProductType {
  id: number;
  text: string;
  description: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
}

